import type { OrderAggregate } from './orders.api';

export type AttentionReason = 'stale' | 'onhold' | 'both' | null;

/**
 * FR16: a row needs the "aandacht nodig" indicator when its last event is older than the
 * staleness threshold, OR its order-level status is onhold. This is a per-row DISPLAY
 * computation on an already-fetched, already-paginated page — never a filter applied across
 * pages (that rule only concerns the "aandacht nodig" preset itself, handled server-side).
 */
export function computeAttentionReason(order: Pick<OrderAggregate, 'status' | 'lastEventAt'>, stalenessDays: number, now: number = Date.now()): AttentionReason {
  const isOnhold = order.status === 'onhold';
  const isStale = order.lastEventAt != null && now - new Date(order.lastEventAt).getTime() > stalenessDays * 24 * 60 * 60 * 1000;
  if (isOnhold && isStale) return 'both';
  if (isOnhold) return 'onhold';
  if (isStale) return 'stale';
  return null;
}
